import { retryWhenJwtAuthError } from './retry-when-jwt-auth-error';
import { JwtAuthHeaders } from '../models/jwt-auth-headers';
import { Observable, switchMap } from 'rxjs';

export function withJwt(
  fetch: (jwtAuthHeaders: JwtAuthHeaders) => Observable<Response>
) {
  return new Observable<JwtAuthHeaders>((subscriber) => {
    subscriber.next(new JwtAuthHeaders());
    subscriber.complete();
  }).pipe(switchMap(fetch), retryWhenJwtAuthError());
}
